<template>
  <v-layout row class="text-xs-center custombackground">
    <v-row justify="center">
      <v-dialog v-model="emailPopup" persistent max-width="400px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex">
            <span>Email ID</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="emailPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-text-field label="Enter Email ID" v-model="email" variant="outlined"
              :rules="[validateEmail]"></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" color="primary" class="cancel-color mb-3 text-none"
              @click="emailPopup = false">Cancel</v-btn>
            <v-btn color="primary" class="mb-3 text-none" :disabled="isSendButtonDisabled() || !email"
              @click="sendEmail">Send</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-flex xs12 sm5 md6 lg7 class="fullheight leftwidth mobilescreenleft">
      <!-- <img src="@/assets/images/LoginImage1.png" style="height:100%;"   class="img-fluid w-100 " /> -->
      <img src="@/assets/images/LoginImage1.png" style="height:100%;"  class="d-none d-sm-block hero-img w-100" />
      <img src="@/assets/images/MobileLoginImg.png" style="height:170px;" class="d-block d-sm-none hero-img" />
      <!-- <div class="hero_carous">
        <h3>
          Transform Reverse Supply Chain
        </h3>
        <h4>
          Blubirch uses data and automation to improve
          <br />omni-channel returns process for better customer
          <br />experience, profitability and sustainability.
        </h4>
      </div> -->
    </v-flex>
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'"
      :timeout="snackbar.timeout" :top="snackbar.position === 'top'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <v-flex xs12 sm7 md6 lg5 class="fullheight rightwidth"  >
      <div class="right-side-background">
        <img src="@/assets/images/bottedbg.png" />
      </div>
      <v-container 
        style="position: relative; background-color: #ffffff;position: relative;z-index: 1;top: -105vh; border-radius: 20px;"
        class="text-xs-center mobile-top-adjust">
        <v-card flat>
          <div class="d-flex flex-column justify-center pt-0 loginform"  v-if="signInAction == 'login'">
            <v-card-title primary-title class="justify-center px-8 pb-3">
              <h1 class="text-center welcome-title" style="word-break: auto-phrase;font-weight: bold; text-wrap:auto; ">Welcome to <span
                  class="logo-style">Blubirch</span></h1>
            </v-card-title>
            <v-form @submit.prevent="handleSubmit" class="pt-0 px-4 pr-2 px-md-10">
              <div class="text-left">
                <label class="paddingleftRight text-font">{{ isMobile ? 'Email ID or username' : 'Email ID or Phone Number or User ID' }}</label>
              </div>
              <v-text-field dense class="paddingleftRight radius-style pt-2 pb-3" v-model="login" variant="outlined"  @paste.prevent="onPaste"
                :placeholder="isMobile ? 'Enter email ID or user name' : 'Enter email ID/phone number/User ID'" rounded="lg" hide-details></v-text-field>
              <v-row v-if="!showPassword">
                <v-col class="text-left text-font pb-2">
                  <label class="paddingleft">Password</label>
                </v-col>
                <v-col class="text-right text-font pb-2">
                  <a href="#" @click="forgotPassowrdClicked" class="forgot-pass-link paddingRight" style="text-decoration: none;">Forgot Password?</a>
                </v-col>
              </v-row>

              <v-text-field dense class="paddingleftRight radius-style pt-2 pb-3" rounded="lg" v-model="password" variant="outlined"  @paste.prevent="onPaste"
                placeholder="Enter Password" :append-inner-icon="value ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append-inner="() => (value = !value)" :type="value ? 'password' : 'text'" rounded-md
                v-if="!showPassword" hide-details/>
              <v-card-actions class="pl-12 pr-14 login-action-btn">
                <v-btn class="text-none"  :disabled="isLoading" :loading="isLoading"
                  style="background-color:#003C9E !important;color:#ffffff;border-radius: 12px;height:48px;"
                  @keyup.enter="signin" type="submit" block v-if="!showPassword">{{ 'Login' }}</v-btn>
                <v-btn class="text-none" style="background-color:#003C9E !important;border-radius: 12px;height:48px;"
                  @keyup.enter="sendOTP" type="submit" color="primary" block v-else>Get OTP</v-btn>
              </v-card-actions>
              <div class="text-center mt-5">
                <span style="color:#A2A3B4;font-size: 600;" v-if="showPassword">Login through Password - <a
                    @click="changeScreen('otp')"
                    style="text-decoration: underline; color: #003C9E;font-size: 14px;font-weight: 600;">Login</a></span>
                <!-- <span style="color:#A2A3B4;font-size: 600;" v-else>Login through OTP - <a
                    @click="changeScreen('password')"
                    style="text-decoration: underline; color: #003C9E;font-size: 14px;font-weight: 600;">Get
                    OTP</a></span> -->
              </div>
              <div v-if="isMobile" class="mobile-otp-section">
                <div class="divider-container ma-0">
                  <div class="custom-divider"></div>
                  <span class="or-text">Or</span>
                  <div class="custom-divider"></div>
                </div>
                <div class="otp-link-container">
                  <a @click="switchToOtpLogin" class="otp-link">Login with OTP</a>
                </div>
              </div>
            </v-form>
          </div>
          <div class="d-flex flex-column justify-center pt-0" :style="isMobile ? '': 'height: 98vh;width: 462px!important;align-items: center; margin: auto;'"
            v-else-if="signInAction == 'otp_verification'">
            <v-card-title primary-title class="justify-center pl-0">
              <h1 :style="isMobile ? 'text-align: left; font-size: 25px' : 'word-break: auto-phrase;font-weight: 700; text-align:center;'"><v-icon x-large
                  @click="signInAction = 'forgot_email_otp_send'" :style="isMobile ? 'font-size: 35px' : 'font-size: 40px'">mdi-chevron-left</v-icon>
                {{ verificationText }}</h1>
            </v-card-title>
            <v-form class="pt-0 px-4 w-100 h-50" @submit.prevent="isMobile ? !mobile_otp_login ? verifyResetPwdOtp() : verifyOtpMobile() : verifyResetPwdOtp()">
              <div style="display: grid; justify-items: left;">
                <label style="font-weight: 700;">Enter OTP</label>
                <span style="color: #6E7089;">sent to {{ this.login }}</span>
              </div>
              <div class="text-end py-5 otp-ui">
                <v-otp-input v-model="input_otp" variant="underlined" length="4"></v-otp-input>
                <div>
                  <a href="#" v-if="this.timer == 0" @click="isMobile ? signInWithOTPMobile() : resendOtp()"><span
                      style="color:#003C9E;font-weight: 600;">Resend
                      OTP</span></a>
                  <span style="color:#003C9E;font-weight: 600;" v-else>00: {{ this.timer }}</span>
                </div>
              </div>
              <v-card-actions>
                <v-btn class="text-none text-white"
                  style="background-color:#003C9E !important;border-radius: 12px;height:48px;color:#ffffff !important;"
                  type="submit" color="primary" block>{{  isMobile ? 'Verify': 'Verify & Log In' }}
                  </v-btn>
              </v-card-actions>
            </v-form>
          </div>
          <div class="d-flex flex-column justify-center pt-0 forgot-pass-screen"
            v-else-if="signInAction == 'forgot_email_otp_send'">
            <!-- <v-card-title primary-title class="justify-center pl-0">
              <h4>Can't log in?</h4>
            </v-card-title> -->
            <v-card-title primary-title class="justify-center pl-0">
              <h1 class="mb-3 fgt-pwd forgot-pass-header">
                <v-icon x-large @click="signInAction = 'login'" class="hidden-sm-and-down" style="font-size: 40px !important;font-weight: 600;">mdi-chevron-left</v-icon>
                Forgot Password?</h1>
              <div v-if="isMobile" class="divider-container">
                  <div class="custom-divider"></div>
              </div>
            </v-card-title>
            <v-form ref="emailForm" @submit.prevent="email_verify" class="forgot-pass-form">
              <div class="forgot-password-label pr-14 pl-12 mb-3 font-weight-bold text-left">{{ isMobile ? 'Confirm your email ID' : 'Confirm your registered email ID or mobile number or User ID' }}</div>
              <v-text-field @keyup.enter="email_verify" class="pr-14 pl-12 email-field email-radius" v-model="email_id"
                :rules="email_id ? emailRules : []"
                :label="isMobile ? 'Enter email ID' : (getInputType(email_id) === 'email' ? 'Enter Email' : (getInputType(email_id) === 'mobile' ? 'Enter Mobile Number' : 'Enter User ID'))"
                variant="outlined" rounded-lg></v-text-field>
              <v-card-actions class="pl-12 pr-14 login-action-btn">
                <v-btn @keyup.enter="signin" type="submit" color="primary" variant="flat" small block class="text-none"
                  style="border-radius: 12px;height:48px;" :disabled="!isEmailValid">Confirm & Get OTP</v-btn>
              </v-card-actions>
              
              <div v-if="isMobile" class="divider-container">
                  <div class="custom-divider"></div>
                    <span class="or-text">Or</span>
                  <div class="custom-divider"></div>
              </div>
              <p class="text-center mobile-only">If you have a username</p>
              <div class="forgot-login-link" style="text-align: center;">
                <a href="#" @click="signInAction = 'login'" style="text-decoration:none;"
                  class="forgot-pass font-style otp-link">{{ isMobile ? 'Request admin for new password' :'Return to Login'}}</a>
              </div>
            </v-form>
          </div>
          <div class="d-flex flex-column justify-center pt-0"
            v-else-if="signInAction == 'login_with_otp' && isMobile">
            <v-card-title primary-title class="justify-center pl-0">
              <h1 class="mb-3 otp-header">
                OTP Login</h1>
              <div class="divider-container">
                  <div class="custom-divider"></div>
              </div>
            </v-card-title>
            <v-form class="login-with-otp-form" @submit.prevent="signInWithOTPMobile">
              <div class="forgot-password-label pr-14 pl-12 mb-3 font-weight-bold text-left">Registered Mobile Number</div>
              <v-text-field class="pr-14 pl-12 email-field email-radius" v-model="login"
                :label="'Enter Mobile Number'"
                variant="outlined" rounded-lg></v-text-field>
              <v-card-actions class="pl-12 pr-14 login-action-btn">
                <v-btn type="submit" color="primary" variant="flat" small block class="text-none"
                  style="border-radius: 12px;height:48px;" :disabled="!login || loading" :loading="loading">Confirm & Get OTP</v-btn>
              </v-card-actions>
              
              <div class="divider-container">
                  <div class="custom-divider"></div>
                    <span class="or-text">Or</span>
                  <div class="custom-divider"></div>
              </div>
              <div class="forgot-login-link" style="text-align: center;">
                <a href="#" @click="signInAction = 'login'" style="text-decoration:none;"
                  class="otp-link">Login With Username & Password</a>
              </div>
            </v-form>
          </div>
          <div class="d-flex flex-column justify-center pt-0" :class="isMobile ? 'px-4' : 'px-16'" :style="isMobile ? 'height: 50vh' : 'height: 98vh'"
            v-else-if="signInAction == 'reset_password'">
            <!-- <v-card-title primary-title class="justify-center pt-4">
              <img src="@/assets/images/login-logo.png" class="login_logo1" />
            </v-card-title>
            <v-card-title primary-title class="justify-center">
              <img src="@/assets/images/Group 19@3 1.png" height="160" width="180" />
            </v-card-title> -->

            <v-card-title primary-title class="justify-left pl-4 pl-md-12 text-left forgot-pass-header">
              <h1 :style="isMobile ? 'font-weight: 700; font-size: 24px;' : 'font-weight: 700;'"><v-icon x-large @click="signInAction = 'login'" :style="isMobile ? 'font-size: 30px;' : 'font-size: 40px;'">mdi-chevron-left</v-icon>
                Reset Password</h1>
            </v-card-title>
            <div class="justify-left pl-4 pl-md-12 pb-4">
              <h6 style="text-align: left;color: #666666;">Create New Password</h6>
            </div>
            <v-form @submit.prevent="resetPassword" ref="resetForm" class="text-left" :class="isMobile ? ['overflow-y-auto', 'dynamic-height-dis-card-dialog'] : ''">
              <label class="pl-4 pl-md-12">New Password</label>
              <v-text-field class="pr-4 pr-md-14 pl-4 pl-md-12" variant="outlined" v-model="new_pwd" label="New password"
                :type="showNewPassword ? 'text' : 'password'" :rules="[validatePassword]"  @paste.prevent="onPaste"
                :append-inner-icon="showNewPassword ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append-inner="showNewPassword = !showNewPassword" @input="validateConfirmPassword()"></v-text-field>

              <label class="pl-4 pl-md-12">Confirm New Password</label>
              <v-text-field class="pr-4 pr-md-14 pl-4 pl-md-12" variant="outlined" v-model="confirm_new_pwd"
                label="Confirm new password" :append-inner-icon="value ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append-inner="() => (value = !value)"  @paste.prevent="onPaste" :type="value ? 'password' : 'text'" :rules="[validatePassword2]"
                @input="validateNewPassword()"></v-text-field>

              <div class="pwd-ui" :class="isMobile ? 'mr-2' : 'mr-12'">
                <span>
                  <v-icon style="color:#003C9E;" class="pr-2">mdi-information-outline</v-icon>Your password must contain
                  at least:
                </span>
                <ul>
                  <li class="pr-10">8 Characters</li>
                  <li class="pr-10">1 digit</li>
                  <li class="pr-10">1 special character</li>
                </ul>
              </div>

              <v-card-actions class="pl-4 pl-md-12 pr-4 pr-md-14">
                <v-btn type="submit" variant="flat" color="primary" small block style="border-radius: 12px; height:48px;"
                  :disabled="saveDisabled || loading">
                  <template v-if="loading">
                    <v-progress-circular indeterminate size="20" color="white"></v-progress-circular>
                  </template>
                  <template v-else>
                    Save & Proceed
                  </template>
                </v-btn>
              </v-card-actions>
            </v-form>
          </div>
          <div class="d-flex flex-column justify-center pt-0 px-16" style="height: 80vh;align-items: center;"
            v-else-if="this.signInAction = 'resetSuccess'">
            <v-icon style="font-size:104px;color:#09A16C;">mdi-check-circle</v-icon>
            <h2 class="text-center">Your Password was reset successfully!</h2>
            <span class="text-center">Login using your new password</span>
            <v-btn @click="signInAction = 'login'" type="submit" color="primary" small
              style="border-radius: 12px;height: 48px;width: 140px;margin: 20px auto;">Login</v-btn>
          </div>

        </v-card>
        <div v-if="!isMobile" class="d-flex flex-column justify-center " style="height: 5vh;">
          <!-- <div class="text-center text-font mt-0">
            <router-link class="orange--text darken-4" to="/privacy_policy">PRIVACY POLICY</router-link>
          </div> -->
          <div class="send-emil text-end" style="position: absolute; bottom: 6px; right: 16px;">
            <v-icon x-large style="font-size: 40px;" color="green" class="mt-3" @click="showEmail">mdi-android</v-icon>
          </div>
        </div>
      </v-container>
    </v-flex>

  </v-layout>
</template>

<script>
import Vue3OtpInput from "vue3-otp-input";
import Loading from 'vue-loading-overlay';
import CryptoJS from 'crypto-js';
import bottedbg from "@/assets/images/bottedbg.png"
export default {
  name: "Signin",
  data() {
    return {
      login: "",
      password: "",
      value: String,
      iconcolor: "grey darken-2",
      loading: false,
      emailPopup: false,
      buttonDisabled: false,
      showPassword: false,
      isLoading: false,
      primary_code: "#000000",
      email: '',
      timer: 60,
      timerInterval: null,
      signInAction: 'login',
      otp: this.$store.state.otp,
      input_otp: '',
      new_user: false,
      email_id: '',
      password_token: '',
      otpKey: 0,
      system_otp: '',
      confirm_new_pwd: '',
      new_pwd: '',
      snackbar: false,
      snackbar: {
        color: null,
        icon: null,
        mode: null,
        position: "top",
        text: null,
        timeout: 7500,
        title: null,
        visible: false
      },
      showNewPassword: false,
      emailRules: [
        v => !!v || "E-mail, phone number, or user ID is required",
        v => {
          const isValidEmail = /.+@.+\..+/.test(v);
          const isValidPhone = /^[0-9]{10}$/.test(v);
          const isValidUserId = /^[a-zA-Z0-9_]+$/.test(v); // Assuming user ID can be alphanumeric with underscores
          return isValidEmail || isValidPhone || isValidUserId || "Must be a valid email, phone number, or user ID";
        }
      ],
      isMobile: false,
      mobile_otp_login: false
    };
  },
  components: {
    Vue3OtpInput,Loading
  },
  mounted() {
    document.addEventListener("contextmenu", this.disableRightClick);
    document.addEventListener('keydown', function (event) {
        if (event.key === 'F12' || ((event.ctrlKey || event.metaKey) && event.shiftKey && ['I', 'C', 'J'].includes(event.key)) || ((event.ctrlKey || event.metaKey) && event.key === 'u')) {
            event.preventDefault();
        }
    });
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    document.removeEventListener("contextmenu", this.disableRightClick);
    document.addEventListener('keydown', function (event) {
        if (event.key === 'F12' || ((event.ctrlKey || event.metaKey) && event.shiftKey && ['I', 'C', 'J'].includes(event.key)) || ((event.ctrlKey || event.metaKey) && event.key === 'u')) {
            event.preventDefault();
        }
    });
    window.removeEventListener('resize', this.checkMobile);
  },
  created() {
    this.checkSignedIn();
    this.signOut();
    this.$store.commit('setSidebarExpanded', false);
    this.domain_baseUrl = `${window.location.protocol}//${window.location.host}`;
  },
  computed: {
    saveDisabled() {
      return !(this.new_pwd && this.validatePassword(this.new_pwd) === true && this.confirm_new_pwd && this.validatePassword2(this.confirm_new_pwd) === true);
    },
    isEmailValid() {
      const isValidEmail = /.+@.+\..+/.test(this.email_id);
      const isValidPhone = /^[0-9]{10}$/.test(this.email_id);
      const isValidUserId = /^[a-zA-Z0-9_]+$/.test(this.email_id); // Assuming user ID can be alphanumeric with underscores
      return isValidEmail || isValidPhone || isValidUserId;
    },
    verificationText() {
      const isValidEmail = /.+@.+\..+/.test(this.email_id);
      const isValidPhone = /^[0-9]{10}$/.test(this.email_id);
      if (isValidPhone) {
        return "Verify mobile number";
      } else if (isValidEmail) {
        return "Verify email address";
      } else {
        return "Verify mobile number";
      }
    }
  },
  updated() {
    this.checkSignedIn();
  },
  watch: {
    isMobile(val) {
      if (!val && this.signInAction === 'login_with_otp') {
        this.signInAction = 'login';
      }
    }
  },
  methods: {
    disableRightClick(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },
    checkMobile() {
      this.isMobile = window.innerWidth < 800;
      this.$store.commit("checkMobile", { isMobile: this.isMobile });
    },
    validatePassword(value) {
      if (!value) return true;
      const regex = /^(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
      if (!regex.test(value) && value != '') {
        return "Invalid password";
      }
      return true;
    },
    validatePassword2(value) {
      if (!value) return true;
      if (value != this.new_pwd) {
        return "Both password must be same";
      }
      return true;
    },
    handleSubmit() {
      if (this.showPassword) {
        this.sendOTP();
      } else {
        this.signin();
      }
    },
    validateEmail(value) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!value) {
        return null
      }
      if (!regex.test(value)) {
        return 'Not a valid email address.';
      }
      const domain = value.split('.').pop();
      if (domain.toLowerCase() !== 'com') {
        return 'Please use a .com email address.';
      }
      return null;
    },
    isSendButtonDisabled() {
      const validationError = this.validateEmail(this.email);
      return !!validationError || this.buttonDisabled;
    },
    showEmail() {
      // this.emailPopup = true;
      if (this.domain_baseUrl == 'https://qa-rims-k8s.blubirch.com' || this.domain_baseUrl == 'https://sandbox-ramp20.blubirch.com' || this.domain_baseUrl == 'https://voltas.blubirch.com') {
        const apkUrl = 'https://voltas-saas-production.s3.ap-south-1.amazonaws.com/fta-app/FTA-Prod.apk';
        window.open(apkUrl, '_blank');
      } else if (this.domain_baseUrl == 'https://qa-reseller.blubirch.com:3805' || this.domain_baseUrl == 'https://reliance-qa-frontend.blubirch.com' || this.domain_baseUrl == 'https://reliance.blubirch.com') {
        const apkUrl = 'https://reliance-saas-production.s3.ap-south-1.amazonaws.com/android/RIMS2-reliance-1.0.76.apk';
        window.open(apkUrl, '_blank');
      }

    },
    sendEmail() {
      this.buttonDisabled = true;
      this.$httpSecured.get(`/profile/send_apk?email=${this.email}`)
        .then((response) => {
          this.email = '';
          this.emailPopup = false;
          this.buttonDisabled = false;
          this.$toast.success(response.data.message)
        })
        .catch((error) => {
          this.loading = false;
          this.$toast.error(error.response.data.error)
          this.buttonDisabled = false;
        });
    },
    signOut() {
      this.$httpSecured
        .delete("/api/v1/logout")
        .then(response => {
          this.$store.commit("unsetCurrentUser");
          this.$store.commit("unsetSelectedLot");
          this.$router.replace("/");
        })
        .catch(error => {
          this.$store.commit("unsetCurrentUser");
          this.$store.commit("unsetSelectedLot");
          // this.$toast.error("Error in logging out");
        });
    },
    aesEncrypt(plainText) {
      const secretKey = CryptoJS.enc.Utf8.parse('5DJe6hOTTctO7Q4pp3y0Txx4i30NhzVT');
      const iv = CryptoJS.enc.Utf8.parse('0000000000000000');
      const encrypted = CryptoJS.AES.encrypt(plainText, secretKey, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      return  encrypted.toString();
    },
    signin() {
      this.loading = true;
      this.isLoading = true; 
      const credentials = this.aesEncrypt(`${this.login}:${this.password}`);
      this.$httpPlain
        .post("/api/v1/login", {
          user: { credentials }
        })
        .then(response => this.signinSuccessful(response))
        .catch(error => this.signinFailed())
        .finally(() => {
          this.loading = false;
          this.isLoading = false;
        });
    },
    signInWithOTPMobile() {
      this.$httpPlain.post("/api/v1/login_with_otp", {
        "login": this.login,
        "type": "mobile"
      })
      .then(response => {
        this.$store.commit('setOTP', { otp: response.data.otp })
        this.$store.commit('setVerificationEmail', { email: this.login })
        this.$toast.success(response.data.message);
        this.startTimer();
        this.signInAction = 'otp_verification';
      })
      .catch(error => {
        this.$toast.error(error.response.data.error);
      })
    },
    verifyOtpMobile() {
      this.$httpPlain.post("/api/v1/verify_login_with_otp", {
        "login": this.login,
        "type": "mobile",
        "otp": this.input_otp
      })
      .then(response => this.signinSuccessful(response))
      .catch(error => this.signinFailed())
      .finally(() => {
        this.loading = false;
        this.isLoading = false;
      });
    },
    async signinSuccessful(response) {
      console.log(response.data.user.fta_logistics_has_taken)
      this.$store.commit("setFTALogistics", { fta_logistics: response.data.user.fta_logistics_has_taken });

      if (!response.headers.authorization) {
        //  this.signinFailed(response);
        return;
      }
      if(response.data.user.is_mobile_role){
        this.$toast.error("You aren't authorized for web application!")
        return
      }

      if (response.data.user.sign_in_count === 1) {
        // this.$router.push({
        //   name: "ResetPassword",
        //   params: { email: response.data.user.email, new_user: true }
        // });
        this.new_user = true;
        this.new_pwd = ''
        this.confirm_new_pwd = ''
        this.signInAction = 'reset_password'
        // this.$refs.resetForm.reset();
        // this.$toast.success(
        //   "Signed in successfully Please change your password first"
        // );
        this.snackbar = true;
        this.snackbar = {
          color: "success",
          icon: "",
          mode: "multi-line",
          position: "top",
          timeout: 5000,
          title: 'Success',
          text: "Signed in successfully Please change your password first",
          visible: true
        };
        return;
      }

      this.new_user = false
      this.$store.commit("setCurrentUser", {
        currentUser: response.data.user,
        authorization: response.headers.authorization
      });    
      if (response.data.user.app_modules.length > 0) {
        const updatedModules = [...response.data.user.app_modules, "Request & Tickets"];
        this.$store.commit("setLeftNavbarEnablity", { app_modules: updatedModules });
      } else {
        this.$store.commit("setLeftNavbarEnablity", { app_modules: [] });
      }
      this.getAccountSetting(response.data.user.roles)
      this.$toast.success("Signed in successfully");
    },
    signinFailed() {
      this.$store.commit("unsetCurrentUser");
      this.$toast.error("Invalid Username & Password", { duration: 1000 });
    },
    checkSignedIn() {
      if (this.$store.state.signedIn) {
        if (this.$store.state.role === "superadmin") {
          this.$router.replace("/admin/roles");
        } else if (this.$store.state.role === "store_user") {
          this.$router.replace("/store/return_request");
        } else if (this.$store.state.role === "dealer_user") {
          this.$router.replace("/dms/orders");
        } else if (this.$store.state.role === "service_executive") {
          this.$router.replace("/management/approveRequest");
        }
      }
    },
    changeScreen(type) {
      if (type == 'password') {
        this.showPassword = true;
      } else {
        this.showPassword = false;
      }
    },
    switchToOtpLogin() {
      this.signInAction = 'login_with_otp';
      this.mobile_otp_login = true
      this.login = '';
    },
    sendOTP() {
      this.loading = true;
      this.$httpPlain.post("/api/v1/password_resets/send_otp", { email: this.login, type: this.getInputType(this.login) })
        .then((response) => {
          if (response.data.status == "unprocessable_entity") {
            this.$toast.error("User not found");
          }
          else {
            this.loading = true;
            this.$store.commit('setOTP', { otp: response.data.otp })
            this.$store.commit('setVerificationEmail', { email: this.login })
            this.$toast.success(response.data.message);
            this.startTimer();
            this.signInAction = 'otp_verification';
          }
        })
        .catch((error) => {
          this.$toast.error(error.response.data.message);
        });

    },
    formatTime(seconds) {
      const remainingSeconds = seconds % 120;
      return `${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    },

    startTimer() {
      this.timer = 60;
      this.timerInterval = setInterval(() => {
        if (this.timer > 0) {
          this.timer--;
        } else {
          clearInterval(this.timerInterval);
        }
      }, 1000);
    },

    verifyResetPwdOtp() {
      this.$httpPlain.put("/profile/verify_reset_pwd_otp",
        {
          email: this.login,
          otp: this.input_otp,
          type: this.getInputType(this.email_id)
        })
        .then((response) => {
          // this.$store.commit('setPasswordToken', {password_token: response.data})
          // this.$store.commit('setOTP', {otp: null})            
          this.$toast.success("Verified");
          this.password_token = response.data.token
          this.$store.commit('setPasswordToken', { password_token: response.data })
          this.$store.commit('setOTP', { otp: null })
          this.signInAction = 'reset_password'
          // this.verifyOTP();
          // this.$router.push({name: "ResetPassword"})
        })
        .catch((error) => {
          this.$toast.error(error.response.data.message);
        });
    },
    // Get OTP Details
    // verifyOTP() {
    //   // if (this.input_otp == this.system_otp) {
    //   this.$httpPlain.post("/api/v1/password_resets/edit",
    //     {
    //       email: this.login,
    //       type: this.getInputType(this.email_id)
    //     })
    //     .then((response) => {
    //       this.password_token = response.data
    //       this.$store.commit('setPasswordToken', { password_token: response.data })
    //       this.$store.commit('setOTP', { otp: null })
    //       // this.signinSuccessful(response)
    //       // this.$toast.success("Email Verified");
    //       this.signInAction = 'reset_password'
    //     })
    //     .catch((error) => {
    //       this.$toast.error(error.response.data.message);
    //     });
    //   // }
    //   // else {
    //   //   this.$toast.error("Entered OTP did not match");
    //   // }
    // },
    resendOtp() {
      this.password_token = null
      // this.$store.commit('setPasswordToken', { password_token: null })
      this.$store.commit('setOTP', { otp: null })
      this.otp = null
      this.input_otp = null
      this.otpKey++;
      this.$httpPlain.post("/api/v1/password_resets/send_otp", { email: this.login, type: this.getInputType(this.email_id) })
        .then((response) => {
          this.otp = response.data
          this.$store.commit('setOTP', { otp: response.data })
          this.$store.commit('setVerificationEmail', { email: this.login })
          this.startTimer();
          this.$toast.success(response.data.message);
          this.otpKey++;
        })
        .catch((error) => {
          this.$toast.error(error.response.data.message);
        });
    },
    getAccountSetting(roles) {
      this.$httpSecured.get("/api/v2/account_setting")
        .then(response => {
          if (response.data) {
            this.$store.commit("currencyFormat", {
              organization_name: response.data.account_setting.organization_name,
              username: response.data.account_setting.username,
              configurations: response.data.configurations,
              data: response.data.account_setting
            });
            this.$store.commit("setActiveIndices",{ activeChildIndex : ''})
            if (roles.includes("store_user")) {
              // this.$router.push({name: 'SearchInvoiceNumber'})
              this.$router.push({ name: "ReturnCreationRia" });
            } else if (roles.includes("service_executive")) {
              // this.$router.push({name: 'PendingApproval'})
              this.$router.push({ name: "ReturnCreationRia" });
            } else if (roles.includes("warehouse")) {
              // this.$router.push({name: 'ReInwardInventry'})
              this.$router.push({ name: "ReturnCreationRia" });
            } else if (roles.includes("superadmin")) {
              this.$router.push({ name: "ListAdminUsers" });
            } else if (roles.includes("dealer_user")) {
              // this.$router.push({name: 'DMSOrders'})
              this.$router.push({ name: "ReturnCreationRia" });
            } else if (roles.includes("forward")) {
              this.$router.push({ name: "ForwardDashboard" });
            } else if (roles.includes("service_franchisee")) {
              this.$router.push({ name: "serviceRequest" });
            } else if(roles.includes("grading_manager")){
              this.$store.commit('setActiveIndices', {
                activeChildIndex: 118
              });
              this.$router.push({ name: "grading" });
            }  else if(roles.includes("cycle_count_manager")){
              this.$store.commit('setActiveIndices', {
                activeChildIndex: 114
              });
              this.$router.push({ name: "PhysicalInspection" });
            } else if(roles.includes("sales_inventory_manager") || roles.includes("lease_inventory_manager") || roles.includes("internal_assets_manager") || roles.includes("production_manager") || roles.includes("buyers_sales_vendors")){
              this.signOut();
              this.$toast.error("Not Authorized to access");
              return;
            }else if(roles.includes("approver")){
              this.$store.commit('setActiveIndices', {
                activeChildIndex: 108
              });
              this.$router.push({ name: "physicalinspectionApproval" });
            } else if((response.data.account_setting.organization_name === 'Voltas'||  this.$isWhirlpoolClient()) && roles.includes("logistics_partner")){
              this.$store.commit('setActiveIndices', {
                activeChildIndex: 106
              });
              this.$router.push({ name: "ftaDisposition" });
            } else if(this.$isRelianceClient() && roles.includes("logistics_partner")){
             this.signOut();
             this.$toast.error("Not Authorized to access");
             return;
            } else if(this.$isRelianceClient() && roles.includes("logistics_manager")){
             this.signOut();
             this.$toast.error("Not Authorized to access");
             return;
            }else if((response.data.account_setting.organization_name === 'Voltas') && roles.includes("logistics_manager")){
              this.$store.commit('setActiveIndices', {
                activeChildIndex: 105
              });
              this.$router.push({ name: "ReverseLogistics" });
            }else if(this.$isWhirlpoolClient() && roles.includes("logistics_manager")){
              this.$router.push({name: 'ftaReverseLogistics'});
              this.$store.commit('setActiveIndices', {
                activeChildIndex: 105
              });
              this.$store.commit("setHeaderTextName",{
                headerTextName : 'Reverse Logistics'
              })
            } else if (this.$isRelianceClient() || roles.includes("restock_manager") || 
              roles.includes("rtv_manager") || roles.includes("markdown_manager") || roles.includes("supplier_manager") || 
              roles.includes("insurance_manager") || roles.includes("cannibalization_manager") || roles.includes("repair_manager") || 
              roles.includes("finance_manager") || roles.includes("liquidation_manager") || roles.includes('management') || (roles.includes('warehouse_manager') && this.$isRelianceClient()) ) {
                this.$store.commit('setActiveIndices', {
                  activeChildIndex: 107
                });
                this.$router.push({ name: "reverseDisposition" });
            }else {
              this.$store.commit('setActiveIndices', {
                activeChildIndex: 101
              });
               this.$store.commit("updateTitle", {
                title: "Return Creation"
              });
              this.$router.push({ name: "ReturnCreationRia" });
            }
          } else {
            this.loading = true;
          }
        })
        .catch(error => {
          this.$toast.error(error.response.data.message);
          // this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    // updateOtp(event) {
    //   this.input_otp = event;
    // },
    //  handlePaste(event) {
    //   event.preventDefault();
    //   const pastedData = event.clipboardData.getData('text').trim();

    //   if (pastedData.length === 4) {
    //     this.input_otp = pastedData;

    //     // Update the OTP input component visually if needed
    //     this.$refs.otpInput.setOtp(pastedData);
    //   }
    // },
    forgotPassowrdClicked() {
      this.email_id = ''
      this.signInAction = 'forgot_email_otp_send'
      this.showPassword = false;
    },
    email_verify() {
      if (this.$refs.emailForm.validate()) {
        let payload = {
          email: this.email_id,
          type: this.getInputType(this.email_id)
        };

        this.$httpPlain.post("/api/v1/password_resets/send_otp", payload)
          .then((response) => {
            if (response.data.status == "unprocessable_entity") {
              this.$toast.error("User not found");
            } else {
              this.system_otp = response.data.otp;
              this.$store.commit('setVerificationEmail', { email: this.email_id });
              this.login = this.email_id;
              this.startTimer();
              this.signInAction = 'otp_verification';
              this.$toast.success(response.data.message);
            }
          })
          .catch((error) => {
            this.$toast.error(error.response.data.message);
          });
      }
    },
    getInputType(input) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const mobileRegex = /^[0-9]{10}$/;

      if (emailRegex.test(input)) {
        return 'email';
      } else if (mobileRegex.test(input)) {
        return 'mobile';
      } else {
        return 'user_id';
      }
    },
    resetPassword() {
      //this.verifyPassword()
      if (this.new_pwd == this.confirm_new_pwd) {
        if (this.new_user) {
          var url = "/api/v1/password_resets/change_password"
          var params = { email: this.login, password: this.new_pwd }
        } else {
          var url = "/api/v1/password_resets/reset"
          var params = { email: this.login, token: this.password_token, password: this.new_pwd }
        }
        this.$httpPlain.post(url, params)
          .then((response) => {
            // this.$store.commit('setVerificationEmail', {email: null})
            // this.$store.commit('setPasswordToken', {password_token: null})
            // this.$store.commit('setVerificationEmail', {email: null})
            // this.$router.push({name: "Signin"}) 
            this.signInAction = 'resetSuccess'
            this.showPassword = false;
            this.$toast.success("Password has been successfully reset");
            this.input_otp = '';
          })
          .catch((error) => {
            this.$toast.error(error.response.data.error);
          });
      }
      else {
        this.$toast.error("Passwords entered are not matching with each other");
      }
    },
    validateNewPassword() {
      this.$refs.resetForm.validate();
    },
    validateConfirmPassword() {
      this.$refs.resetForm.validate();
    }
  }
};
</script>

<style type="text/css" scoped>
.form-signin {
  width: 70%;
  max-width: 500px;
  padding: 10% 15px;
  margin: 0 auto;
}

.signin_left_margin {
  margin-left: -100px;
}

.fullheight {
  height: 100vh;
}


.responsive-img {
  max-width: 21vw;
  height: auto;
  max-height: 30vh;
}

.responsive-logo {
  height: 105px;
}

.text-font {
  font-size: 14px;
  font-weight: 600;
  color: #1A1B35;
}

.logo-style {
  background: linear-gradient(152.9deg, #5EC3E6 11.99%, #19429B 120.9%);
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
}

:deep(.v-text-field .v-input__slot) {
  box-shadow: none !important;
  min-height: 48px !important;
}

:deep(.otp-container input) {
  border-bottom: 2px solid #316EC4;
  width: 60px;
  margin: 5px 20px;
  text-align: center;
}

.otp-container {
  text-align: center;
}

.right-side-background {
  /* background-image: url(`bottedbg`); */
  height: 100vh;
  overflow: hidden;
  opacity: 1;
  z-index: 2;
  position: relative;
  width: 17%;
}

.pwd-ui {
  background-color: #E1EEFA;
  border-radius: 12px;
  padding: 10px;
  margin: 0px 20px;
}

.pwd-ui ul {
  padding: 26px;
  display: flex;
}

.pwd-ui li {
  padding-right: 40px;
}


.hero-img-desktop {
  width: 100%;
  height: 100%;
  object-fit: cover; 
}

/* Mobile image styling */
.hero-img-mobile {
  width: 100%;
  height: auto; 
  object-fit: contain; 
  margin-top: 10px;
}

.loginform{
  height: 98vh;
}
.leftwidth{
  width: 58%;

}
.rightwidth{
  width: 48%;
}
.forgot-pass-screen{
  height: 98vh;

}

.forgot-pass-header{
  font-weight: 700;
}

.mobile-only {
  display: none;
}
.forgot-pass-form{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  padding-top: 0;
}

@media (max-width:600px){
  .text-xs-center{
    display: flex;
    flex-direction: column;
  }
  .right-side-background {
    display: none;
  }
  .fullheight {
    height: 100%;
    width: unset;
  }
  .loginform{
    height: unset;
  }
  .welcome-title {
    font-size: 20px; 
    white-space: nowrap !important; 
    overflow: hidden;               
    text-overflow: ellipsis;        
  }
  .mobilescreenleft{
    background-color: #00114B;
    height: calc(var(--vh, 1vh) * 100 - 390px) !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .mobile-top-adjust {
    margin-top: -5vh;
    top: unset !important;
  }

  .mobile-otp-section {
    margin-top: 20px;
    text-align: center;
   
  }
  .divider-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
  }
  .or-text {
    margin: 0 10px;
    color: #6E7089;
    font-weight: 600;
  }
  .custom-divider {
    height: 1px;
    background-color:#EAEAF4;
    flex-grow: 1;
  }
  .otp-link {
    color: #003C9E;
    font-weight: 700;
    text-decoration: none;
    font-size: 16px;
    cursor: pointer;
  }

  .login-action-btn {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .forgot-pass-link {
    color: #003C9E !important;
  }
  .forgot-pass-screen{
    height: unset;
  }
  .forgot-pass-header{
    font-size: 20px !important;
    font-weight: 600 !important;
    display: flex;
  }

   .mobile-only {
      display: block;
      margin: 8px 0;
      font-size: 14px;
      text-align: center;
  }

  .forgot-password-label {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .forgot-login-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .email-field{
    display: contents;
  }
  .email-radius .v-field__outline {
    border-radius: 20px !important;
    
  }

  .forgot-pass-form{
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 0;
  }
  .otp-header{
    font-size: 20px !important;
    font-weight: 600 !important;
    display: flex;
  }
  .pwd-ui {
    margin: 0px 16px;
  }
  .pwd-ui ul {
    padding: 10px;
  }
  .pwd-ui li {
    padding-right: 10px;
  }
 
}




@media (max-width: 1680px) {
  .otp-ui {
    padding: 50px 0px !important;
  }

  .pwd-ui ul {
    display: block;
  }
  .fgt-pwd {
    font-size: 34px;
  }

}

@media (min-width: 1100px) {
  .paddingleftRight {
    padding-right: 56px !important;
    padding-left: 48px !important;
  }

  .paddingleft {
    padding-left: 48px !important;
  }

  .paddingRight {
    padding-right: 56px !important;
    color:#0f1499;
    font-size: 14px;
    font-weight: 600;
  }
}
:deep(.v-otp-input .v-otp-input__content){
  max-width: 100% !important;
  gap: 2rem !important;
}
.custombackground{
  background-color: #ffffff !important;
 
}
:deep(.radius-style .v-field__input){
  border-radius: 8px !important;
}
.dynamic-height-dis-card-dialog {
    height: calc(var(--vh, 1vh) * 100 - 400px) !important;
  }
</style>